import React from "react";
import {useUserQuery} from "../query/userQuery";

interface Props {
    userId: number;
}

const UserName: React.FC<Props> = ({ userId }) => {
    const {data: userInfo} = useUserQuery(userId);

    return userInfo ? <span>{userInfo.name}</span> : null;
};

export default UserName;
